import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgHome = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21.9948 11.9808C21.9948 12.6059 21.4738 13.0956 20.8834 13.0956H19.772L19.7963 18.6596C19.7963 18.7533 19.7893 18.8471 19.7789 18.9409V19.5035C19.7789 20.2711 19.1572 20.8928 18.3897 20.8928H17.834C17.7958 20.8928 17.7575 20.8928 17.7193 20.8893C17.6707 20.8928 17.6221 20.8928 17.5735 20.8928L16.4447 20.8893H15.6112C14.8436 20.8893 14.2219 20.2676 14.2219 19.5001V18.6665V16.4437C14.2219 15.829 13.7253 15.3323 13.1105 15.3323H10.8877C10.273 15.3323 9.77632 15.829 9.77632 16.4437V18.6665V19.5001C9.77632 20.2676 9.15463 20.8893 8.38707 20.8893H7.55352H6.44559C6.3935 20.8893 6.3414 20.8858 6.2893 20.8824C6.24763 20.8858 6.20595 20.8893 6.16427 20.8893H5.60857C4.84101 20.8893 4.21932 20.2676 4.21932 19.5001V15.6102C4.21932 15.5789 4.21932 15.5442 4.2228 15.5129V13.0922H3.1114C2.48624 13.0922 2 12.6059 2 11.9773C2 11.6647 2.10419 11.3869 2.34731 11.1437L11.2489 3.38478C11.492 3.14166 11.7699 3.10693 12.013 3.10693C12.2561 3.10693 12.534 3.1764 12.7424 3.35005L21.6127 11.1472C21.8906 11.3903 22.0295 11.6682 21.9948 11.9808Z", fill: props.fill }));
});
export default SvgHome;
